import {debounce} from 'throttle-debounce';
import {h, render} from 'preact';
import {useRef, useEffect, useMemo, useState} from 'preact/hooks';
import Results from "./Components/SearchResult/Results";
import SearchBar from "./Components/SearchBar";

(() => {

    function SearchContents({path, nodeRef, csrfToken}) {
        const [error, setError] = useState();
        const [isLoaded, setIsLoaded] = useState();
        const [results, setResults] = useState();
        const [facets, setFacets] = useState({type: [], viewed: []});
        const formData = useRef();

        const search = async (event) => {
            const form = formData.current;
            const query = form.query.value || '';
            const value = event.target.value || '';
            const filter = {};

            if (value.indexOf(':') !== -1) {
                form.typeFilter && (filter['type'] = form.typeFilter.value);
                form.viewedFilter && (filter['viewed'] = form.viewedFilter.value.substring(1));
            }

            try {
                const response = await fetch(`/api/search`,
                    {
                        cache: "no-cache",
                        method: "POST",
                        body: JSON.stringify({q: encodeURIComponent(query), filter: filter, node: nodeRef, path: path}),
                        credentials: 'same-origin',
                        headers: {
                            'X-Flow-Csrftoken': csrfToken,
                            'Content-Type': 'application/json'
                        }
                    });
                if ((response.status === 200)) {
                    const res = await response.json();
                    setIsLoaded(true);
                    setResults(res.results);
                    setFacets(res.facets);
                }
            } catch (error) {
                setIsLoaded(true);
                setError(error);
            }
        }

        const debouncedSearch = useMemo(
            () => debounce(350, search),
            []
        );

        const handleSubmit = (ev ) => {
            ev.preventDefault();
            let current = formData.current;
           // console.log(
           //     'Submit', current.query.value,
           //     current.typeFilter.value
           // );

        };

        useEffect(() => {
            return () => {
                debouncedSearch.cancel();
            }
        }, []);

        useEffect(() => {
            // First empty search
            search({target: {value: null}});
        }, []);

        return (
            <div className="oSearchContents">
                <div className="oSearchContents__Mask--toggler"></div>
                <form onSubmit={handleSubmit} ref={formData} >
                    <SearchBar facets={facets} onChange={debouncedSearch} />
                </form>
                <Results items={results}/>
            </div>
        );
    }

    window.addEventListener('DOMContentLoaded', () => {
        const searchContents = document.querySelector('#SearchContents');
        if (!searchContents) return;
        const {path, node, token} = searchContents.dataset;
        if (path === '' || node === '' || token === '') return;

        render(<SearchContents path={path} nodeRef={node} csrfToken={token} />, searchContents);
    });
})();
